enum AccessReportsWizardNetworkStandardTypeEnum {
  Standard = "Standard",
  ZipUrban = "ZipUrban",
  ZipSuburban = "ZipSuburban",
  ZipRural = "ZipRural",
  CountyLarge = "CountyLarge",
  CountyMetro = "CountyMetro",
  CountyMicro = "CountyMicro",
  CountyRural = "CountyRural",
  CountyCEAC = "CountyCEAC",
}

export { AccessReportsWizardNetworkStandardTypeEnum };
